import { render } from "./contact.vue?vue&type=template&id=7d81ba47&scoped=true"
const script = {}

import "./contact.vue?vue&type=style&index=0&id=7d81ba47&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.29_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d81ba47"]])

export default __exports__